// extracted by mini-css-extract-plugin
export default {"quote":"Testimonials_quote__Trx7Q","primaryText":"Testimonials_primaryText__yEPZB","stars":"Testimonials_stars__lrINw","card":"Testimonials_card__L6TeL"};